export var globalConfig: any =
{
    leaderboardUrl: 'https://power-patrol.ppp-leaderboards.com'
};



// WEBPACK FOOTER //
// ./src/ts/config/Config.ts